import React from 'react'
import { useTranslation } from 'react-i18next'

//
import { User } from 'core/application/account/loginUser'

import Icon from '../../../../assets/images/perks-dashboard-home-setup-icon.svg'
import GreetingAdminMessage, { GreetingStatus } from '../../common/GreetingAdminMessage/GreetingAdminMessage'

type SetupHeaderProps = {
  user: User
}

function SetupHeader({ user }: SetupHeaderProps) {
  const { t: translate } = useTranslation()
  return (
    <>
      <div className="align_self_center mt-24 mb-24">
        <img src={Icon} alt="dashboard-logo" className="" />
      </div>

      <GreetingAdminMessage status={GreetingStatus.GENERAL} user={user} />

      <p className="gray-7 mb-16">{translate('admin-dashboard.home.welcome-setup-description')}</p>
    </>
  )
}

export default SetupHeader
